import { motion, useReducedMotion } from 'framer-motion';

// Opacity-only reveals leave CSS transforms (project fans and hover effects) intact.
export const Reveal = ({ as = 'div', children, delay = 0, distance = 18, duration = 0.6, ...props }) => {
  const reduceMotion = useReducedMotion();
  const Component = motion[as];
  const hidden = distance === 0 ? { opacity: 0 } : { opacity: 0, y: distance };
  const visible = distance === 0 ? { opacity: 1 } : { opacity: 1, y: 0 };

  return (
    <Component
      initial={reduceMotion ? false : hidden}
      whileInView={visible}
      viewport={{ once: true, amount: 0.15, margin: '0px 0px -24px 0px' }}
      transition={{ duration: reduceMotion ? 0 : duration, delay: reduceMotion ? 0 : delay, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >
      {children}
    </Component>
  );
};

export const TextReveal = ({ as: Component = 'h2', className = '', children, delay = 0, ...props }) => (
  <Component className={`pf-text-reveal ${className}`.trim()} {...props}>
    <Reveal as="span" className="pf-text-reveal-inner" delay={delay} distance={26} duration={0.7}>
      {children}
    </Reveal>
  </Component>
);
